export const caribbeanCountries = ['AW', 'BQ', 'CW', 'SX'];
